import { Stack } from "@mui/material";

interface CartStackProps {
  children?: React.ReactNode;
}

export function CartStack({ children }: CartStackProps) {
  return (
    <Stack
      sx={{ maxWidth: "lg", mx: "auto", width: "100%", display: "flex", alignItems: "center" }}
      spacing={2}
    >
      {children}
    </Stack>
  );
}
